<template>
  <el-dialog :title="'库区库位 - ' + (wareHouseName || '')" :visible.sync="visible" width="min(960px, calc(100vw - 32px))" :close-on-click-modal="false" @close="areas = []">
    <div style="margin-bottom:12px">
      <el-button v-if="isAuth('base:wareHouseArea:save')" type="primary" size="small" @click="openAreaForm(null, '0')">添加库区</el-button>
    </div>
    <el-table :data="areaRows" border v-loading="areaLoading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column label="名称" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope"><span :style="{ paddingLeft: (scope.row._level || 0) * 18 + 'px' }">{{ scope.row.wareAreaName }}</span></template>
      </el-table-column>
      <el-table-column prop="wareHouseName" label="仓库名称" show-overflow-tooltip />
      <el-table-column label="类型" width="80"><template slot-scope="scope">{{ scope.row.type === '0' ? '库区' : '库位' }}</template></el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip />
      <el-table-column prop="sort" label="排序" width="80" align="center" />
      <el-table-column label="启用状态" width="80" align="center">
        <template slot-scope="scope"><el-tag :type="scope.row.isenabled === '1' ? 'danger' : 'success'" size="small">{{ scope.row.isenabled === '1' ? '禁用' : '启用' }}</el-tag></template>
      </el-table-column>
      <el-table-column prop="createByName" label="创建人" width="80" />
      <el-table-column label="创建日期" width="100" align="right"><template slot-scope="scope">{{ String(scope.row.createDate || '').substr(0, 10) }}</template></el-table-column>
      <el-table-column prop="updateByName" label="修改人" width="80" />
      <el-table-column label="修改日期" width="100" align="right"><template slot-scope="scope">{{ String(scope.row.updateDate || '').substr(0, 10) }}</template></el-table-column>
      <el-table-column fixed="right" label="操作" width="180" align="center">
        <template slot-scope="scope">
          <el-button v-if="isAuth('base:wareHouseArea:update')" type="text" size="small" @click="openAreaForm(scope.row, scope.row.type)">修改</el-button>
          <el-button v-if="isAuth('base:wareHouseArea:delete')" type="text" size="small" @click="removeArea(scope.row)">删除</el-button>
          <el-button v-if="isAuth('base:wareHouseArea:location') && scope.row.type === '0'" type="text" size="small" @click="openAreaForm(null, '1', scope.row)">添加库位</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer"><el-button @click="visible = false">关闭</el-button></span>

    <el-dialog :title="areaTitle" :visible.sync="areaFormVisible" width="min(480px, calc(100vw - 32px))" append-to-body :close-on-click-modal="false">
      <el-form ref="areaForm" :model="area" :rules="areaRules" label-width="100px">
        <el-form-item :label="area.type === '0' ? '库区名称' : '库位名称'" prop="wareAreaName">
          <el-input v-model="area.wareAreaName" :placeholder="area.type === '0' ? '库区名称' : '库位名称'" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="area.sort" :min="0" :precision="0" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="area.remark" type="textarea" :rows="3" placeholder="备注" />
        </el-form-item>
        <el-form-item label="启用状态" prop="isenabled">
          <el-radio-group v-model="area.isenabled">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="areaFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveArea">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false, areaFormVisible: false, areaLoading: false, areaTitle: '添加库区',
      areas: [], area: {}, wareHouseId: '', wareHouseName: '', permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' },
      areaRules: {
        wareAreaName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        isenabled: [{ required: true, message: '请选择启用状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    areaRows() {
      const map = {}
      ;(this.areas || []).forEach(row => { map[row.wareAreaId] = { ...row, children: [] } })
      const roots = []
      ;(this.areas || []).forEach(row => {
        const node = map[row.wareAreaId]
        if (row.parentId && map[row.parentId]) map[row.parentId].children.push(node)
        else roots.push(node)
      })
      const out = []
      const walk = (nodes, level) => nodes.forEach(node => {
        out.push({ ...node, _level: level })
        walk(node.children || [], level + 1)
      })
      walk(roots, 0)
      return out
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    init(wareHouseId, wareHouseName) {
      this.wareHouseId = wareHouseId
      this.wareHouseName = wareHouseName || ''
      this.visible = true
      this.loadAreas()
    },
    loadAreas() {
      this.areaLoading = true
      request.get('/base/wareArea/list/' + this.wareHouseId).then(res => { this.areas = res.data || [] }).catch(() => { this.areas = [] }).finally(() => { this.areaLoading = false })
    },
    openAreaForm(row, type, parentArea) {
      this.areaFormVisible = true
      this.$nextTick(() => {
        if (this.$refs.areaForm) this.$refs.areaForm.clearValidate()
        if (row) {
          this.areaTitle = type === '0' ? '修改库区' : '修改库位'
          this.area = {
            wareAreaId: row.wareAreaId, wareAreaName: row.wareAreaName, wareHouseId: row.wareHouseId,
            type: row.type, parentId: row.parentId || '', sort: row.sort || 0, remark: row.remark || '', isenabled: row.isenabled || '0'
          }
        } else {
          this.areaTitle = type === '0' ? '添加库区' : '添加库位'
          this.area = {
            wareAreaName: '', wareHouseId: this.wareHouseId, type, parentId: parentArea ? parentArea.wareAreaId : '',
            sort: 0, remark: '', isenabled: '0'
          }
        }
      })
    },
    saveArea() {
      this.$refs.areaForm.validate(valid => {
        if (!valid) return
        request.post('/base/wareArea/' + (this.area.wareAreaId ? 'update' : 'save'), this.area).then(() => {
          this.$message.success('操作成功')
          this.areaFormVisible = false
          this.loadAreas()
        }).catch(() => {})
      })
    },
    removeArea(row) {
      this.$confirm('确定删除?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        request.post('/base/wareArea/delete', { wareAreaId: row.wareAreaId }).then(() => {
          this.$message.success('操作成功')
          this.loadAreas()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>
